import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const patchStory = ({ id, params }) =>
  HttpClient().patch(`/stories/v2/${id}`, params)

const updateStory =
  ({ storyId, update, callback, promise }) =>
  (dispatch) =>
    patchStory({
      id: storyId.toString(),
      params: {
        data: {
          attributes: {
            ...update,
          },
          id: storyId,
          type: 'story',
        },
      },
    })
      .then((response) => {
        const responseData = response.data
        if (callback) callback(promise, responseData.data)
        return dispatch(loadJsonApiEntities(responseData))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })

export default updateStory
